/* eslint-disable no-buffer-constructor */
import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import { FilterModel } from "../../../domain/models/enum";
import {
  FiscalNoteResponseModel,
  Recurrency,
  RecurrenceMonthlyStatus,
} from "../../../domain/models/fiscal-note";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteRecurrency implements Recurrency {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpClient,
    private readonly baseUrl: string | undefined
  ) { }


  async loadNotesByIdRecurrency(id: number, params?: FilterModel): Promise<FiscalNoteResponseModel> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/${id}`,
      method: "get",
      params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.badRequest:
        throw httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async getMonthlyStatus(id: number): Promise<RecurrenceMonthlyStatus> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/${id}/monthly-status`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.badRequest:
        throw httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }
}
